export const CLASS_NAMES = {
  container: 'flex flex-row',
  sidebar: 'flex md::w-72 mr-8 lg:mr-18',
  content: 'flex flex-col flex-1 $width mt-3',
};
